import React from 'react';
import Header from './Header';

/**
 * Reusable Placeholder Screen component
 * Used for features that are not yet implemented
 */
export function PlaceholderScreen({ title, icon, description, onBack }) {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header title={title} icon={icon} onBack={onBack} />
      
      <div className="flex flex-col items-center justify-center p-8 mt-20">
        <div className="w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center mb-6">
          <span className="text-5xl">{icon}</span>
        </div>
        <h2 className="text-xl font-bold text-gray-800 mb-2">{title}</h2>
        <p className="text-gray-500 text-center max-w-xs">{description}</p>
        <p className="text-gray-400 text-sm mt-4">Coming Soon</p>
      </div>
    </div>
  );
}

export default PlaceholderScreen;
